import styled from 'styled-components';
import React, { useState, useEffect, useContext } from 'react';
import { useSpring, animated } from 'react-spring';
import axios from 'axios';
import { PredContext } from './sportsc/predContext';
import { PriceContext } from './context';

// --- NEW STYLED COMPONENTS FOR THE MENU ---

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 320px;
  padding: 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
`;

const StatButton = styled.button`
  background-color: #0e141b;
  color: white;
  padding: 18px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover { background-color: #1e293b; transform: translateY(-2px); }
  &:active { transform: scale(0.98); }
`;

const CloseButton = styled(StatButton)`
  background-color: #ef4444;
  margin-top: 10px;
  &:hover { background-color: #dc2626; }
`;

const BackBtn = styled.button`
  background: #e2e8f0;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  margin-bottom: 10px;
`;

// --- EXISTING STYLED COMPONENTS ---

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 24px;
  top: 0;
  background-color: #f8fafc;
  z-index: 10;
  border-bottom: 2px solid #e2e8f0;

`;

const HeaderCell = styled.div`
  font-weight: 700;
  font-size: 0.75rem;
  color: #475569;
  text-transform: uppercase;
  padding: 10px 0;
  text-align: center;
`;

const ArticleContainer = styled(animated.div)`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Changed to 3 for filtered views */
  gap: 10px; 
  width: 100%;
  height: auto;
  max-height: 70vh;
  overflow-y: auto;
  padding: 16px;
  background-color: #f8fafc;
  border-radius: 8px;
`;

const ActContainer = styled(animated.div)`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Changed to 3 for filtered views */
  gap: 10px; 
  width: 100%;
  height: auto;
  max-height: 70vh;
  overflow-y: auto;
  padding: 16px;
  background-color: #f8fafc;
  border-radius: 8px;
`;
const TeamSquare = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  aspect-ratio: 1.5 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  color: #0e141b;
  text-align: center;
  padding: 4px;
`;

const FullScreenOverlay = styled(animated.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.98);
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`;

const SectionTitle = styled.h2`
  color: #0d141c;
  font-size: 1.375rem;
  font-weight: bold;
  padding: 1.25rem 1rem 0.75rem;
`;

const GameAnalysisContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background-color: #f8fafc;
`;

const SubscriptionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: white;
  margin: 0 1rem 0.5rem;
  padding: 0 1rem;
  min-height: 4.5rem;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const GameAnalysisTitle = styled.p`
  color: #0e141b;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
`;

const IconContainer = styled.div`
  color: #0d141c;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background-color: #e7edf4;
  width: 3rem;
  height: 3rem;
`;

// --- UTILS ---

function shortenValue(val) {
  if (typeof val === 'string' && isNaN(val)) return val;
  return Number(val).toFixed(2);
}

function orderTeam(teamData) {
  console.log('team data in order', teamData)
  let count = 0;
  let groups = {};
  for (let i = 0; i < teamData.length; i++) {
    let row = [...teamData[i]]; 

    let teamName = row.length <= 5 ? row[4] : row[7];
    console.log(row.length)
    console.log('mouse', teamName)
    //if (row.length > 5) { row[1] = 0; row[3] = 0; row[5] = 0; }

    const cleanRow = row.slice(0, -1);
    if (!groups[teamName]) {
      groups[teamName] = { team: teamName, data: [cleanRow], id: count };
      count++;
    } else { groups[teamName].data.push(cleanRow); }
  }
  console.log('fishes')
  console.log(groups)
  return Object.values(groups).map(group => ({
  ...group,
  data: group.data
    .filter(playerRow => playerRow[3] !== 'Reserves')
    .sort((a, b) => {
      const nameA = a[3] ?? '';
      const nameB = b[3] ?? '';
      return String(nameA).localeCompare(String(nameB));
    })
}));
}

// return Object.values(groups).map(group => {
//   return {
//     ...group,
//     data: group.data
//       // 1. Remove the row if the player name (index 6) is 'Reserves'
//       .filter(playerRow => playerRow[4] !== 'Reserves')
//       // 2. Sort by the player name (index 6)
//       .sort((a, b) => a[6].localeCompare(b[6]))
//   };
// });

// --- COMPONENTS ---

function Article({ teamData, statType }) {

  if (teamData.data[0].length >5) {
    console.log(teamData)
    console.log('rice')

      const mapping = {
    points: { indices: [0, 4, 3], headers: ["Pts Pred", "Act","Player"] },
    assists: { indices: [1, 5, 3], headers: ["Ast Pred", "Act", "Player"] },
    rebounds: { indices: [2,6, 3], headers: ["Reb Pred", "Act", "Player"] }
  };

  const current = mapping[statType];

  return (
        <ActContainer>
      {current.headers.map((h, i) => (
        <TeamSquare key={`h-${i}`} style={{ background: '#f1f5f9', fontWeight: 'bold' }}>
          {h}
        </TeamSquare>
      ))}
      {teamData.data.map((playerRow, rIdx) => (
        current.indices.map((cIdx) => (
          <TeamSquare key={`${rIdx}-${cIdx}`}>
            {playerRow[cIdx]}
          </TeamSquare>
        ))
      ))}
    </ActContainer>
  )
  }
  // Column Indices: 0:PtsP, 1:PtsA, 2:AstP, 3:AstA, 4:RebP, 5:RebA, 6:Player
  const mapping = {
    points: { indices: [0,  3], headers: ["Pts Pred", "Player"] },
    assists: { indices: [1,  3], headers: ["Ast Pred",  "Player"] },
    rebounds: { indices: [2, 3], headers: ["Reb Pred", "Player"] }
  };

  const current = mapping[statType];

  return (
    <ArticleContainer>
      {current.headers.map((h, i) => (
        <TeamSquare key={`h-${i}`} style={{ background: '#f1f5f9', fontWeight: 'bold' }}>
          {h}
        </TeamSquare>
      ))}
      {teamData.data.map((playerRow, rIdx) => (
        current.indices.map((cIdx) => (
          <TeamSquare key={`${rIdx}-${cIdx}`}>
            {playerRow[cIdx]}
          </TeamSquare>
        ))
      ))}
    </ArticleContainer>
  );
}

const FullArticle = ({ onClose }) => {
  const [article, setOneArticle] = useState(null);
  const [view, setView] = useState('menu'); // 'menu' | 'points' | 'assists' | 'rebounds'
  const { teamData, id } = useContext(PredContext);

  useEffect(() => {
    const found = teamData.find((art) => art.id === id);
    if (found) {
      const cleaned = {
        ...found,
        data: found.data.map(player => player.map(cell => shortenValue(cell)))
      };
      setOneArticle(cleaned);
      console.log('donkey',teamData)
    }
  }, [teamData, id]);

  const props = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: { duration: 200 }
  });

  if (!article) return null;

  return (
    <FullScreenOverlay style={props}>
      {view === 'menu' ? (
        <MenuContainer>
          <h2 style={{ textAlign: 'center', marginBottom: '10px' }}>{article.team}</h2>
          <StatButton onClick={() => setView('points')}>Points</StatButton>
          <StatButton onClick={() => setView('assists')}>Assists</StatButton>
          <StatButton onClick={() => setView('rebounds')}>Rebounds</StatButton>
          <CloseButton onClick={onClose}>Close</CloseButton>
        </MenuContainer>
      ) : (
<div style={{ 
  display: 'grid', 
  gridTemplateRows: '10% 90%', // 20% for Header, 80% for Article
  width: '100%', 
  maxWidth: '600px',
  height: '100vh',            // Required for percentage rows to work
  overflow: 'hidden'          // Keeps the main container from scrolling
}}>          <HeaderContainer>
            <BackBtn onClick={() => setView('menu')}>← Back</BackBtn>
            <span style={{ fontWeight: 'bold', color: 'black' }}>{view.toUpperCase()}</span>
            <div style={{ width: '60px' }}></div>
          </HeaderContainer>
          <Article teamData={article} statType={view} />
        </div>
      )}
    </FullScreenOverlay>
  );
};

function TeamData() {
  const [showFullArticle, setShowFullArticle] = useState(false);
  const { email } = useContext(PriceContext);
  const { teamData, setTeamData, setId } = useContext(PredContext);

  const predCheck = async () => {
    console.log('dragons')
    try {
      const response = await axios({
        method: 'post',
        url: `https://dhqs56xckk.execute-api.us-east-2.amazonaws.com/pred_dev/load`,
        data: { email: email, path: 'team-data' },
      });
      const teamDataOrganized = orderTeam(response.data.data);
      console.log('birds')
      console.log(teamDataOrganized)
      setTeamData(teamDataOrganized);

      console.log('organs')
      console.log(teamDataOrganized)
    } catch (error) {
      console.error('Error fetching team data:', error.message);
    }
  };

  useEffect(() => { predCheck(); }, []);

  return (
    <GameAnalysisContainer>
      {showFullArticle && <FullArticle onClose={() => setShowFullArticle(false)} />}
      <SectionTitle>Team Predictions</SectionTitle>
      {teamData.map((team) => (
        <SubscriptionItem key={team.id}>
          <IconContainer>
            <svg width="24" height="24" fill="currentColor" viewBox="0 0 256 256">
              <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,112h-8a32,32,0,0,1,0-64h8ZM32,96h8a32,32,0,0,1,0,64H32Zm0,80h8a48,48,0,0,0,0-96H32V64h88V192H32Zm192,16H136V64h88V80h-8a48,48,0,0,0,0,96h8v16Z"></path>
            </svg>
          </IconContainer>
          <GameAnalysisTitle onClick={() => { setId(team.id); setShowFullArticle(true); }}>
            {team.team}
          </GameAnalysisTitle>
        </SubscriptionItem>
      ))}
    </GameAnalysisContainer>
  );
}

export default TeamData;